/* A4 Gallery — homepage intro film (v2)
   Artworks and event photos drift in as large cards, then spin and flip
   into each phrase of "CREATE A BRIGHTER FUTURE WITH ART.", then
   "A4 GALLERY", then the A4 mark — resolving into the logo. */
(function () {
  'use strict';

  var MARK = { c: 112, r: 125, rows: ["0000000000000000000000000000", "0000000000000000000100000000", "0000000000000000000300000000", "0000000000000000000300000000", "0000000000000000000700000000", "0000000000000000000f00000000", "0000000000000000001f00000000", "0000000000000000001f00000000", "0000000000000000003f00000000", "0000000000000000007f00000000", "000000000000000000ff00000000", "000000000000000000ff00000000", "000000000000000001ff00000000", "000000000000000003ff00000000", "000000000000000007ff00000000", "000000000000000007ff00000000", "00000000000000000fff00000000", "00000000000000001fff00008000", "00000000000000003fff00010000", "00000000000000003fff00030000", "00000000000000007fff00070000", "0000000000000000ffff00070000", "0000000000000000ffff000f0000", "0000000000000001ffff001f0000", "0000000000000003ffff003f0000", "0000000000000007ffff003f0000", "0000000000000007ffff007f0000", "000000000000000fffff00ff0000", "000000000000001fffff00ff0000", "000000000000003fffff01ff0000", "000000000000003fffff03ff0000", "000000000000007fffff07ff0000", "00000000000000ffffff07ff0000", "00000000000001ffffff0fff0000", "00000000000001ffffff1fff0000", "00000000000003ffffff3fff0000", "00000000000007ffffff3fff0000", "00000000000007ffffff7fff0000", "0000000000000ffff7ffffff0000", "0000000000001fffe7ffffff0000", "0000000000003fffe7ffffff0000", "0000000000003fffc7ffffff0000", "0000000000007fff87ffffff0000", "000000000000ffff07ffffff0000", "000000000000ffff07ffffff0000", "000000000001fffe07ffffff0000", "000000000003fffc07ffffff0000", "000000000007fff807ffffff0000", "000000000007fff807ffffff0000", "00000000000ffff007ffffff0000", "00000000001fffe007ffffff0000", "00000000003fffc007ffffff0000", "00000000003fffc007ffffff0000", "00000000007fff8007ffffff0000", "0000000000ffff0007ffffff0000", "0000000001ffff0007fff7ff0000", "0000000001fffe0007ffe7ff0000", "0000000003fffc0007ffc7ff0000", "0000000007fff80007ffc7ff0000", "000000000ffff80007ff87ff0000", "000000000ffff00007ff07ff0000", "000000001fffe00007ff07ff0000", "000000003fffc00007ff07ff0000", "000000003fffc00007ff07ff0000", "000000007fff800007ff07ff0000", "00000000ffff000007ff07ff0000", "00000001fffe000007ff07ff0000", "00000001fffe000007ff07ff0000", "00000003fffc000007ff07ff0000", "00000007fff8000007ff07ff0000", "0000000ffff8000007ff07ff0000", "0000000ffff0000007ff07ff0000", "0000001fffe0000007ff07ff0000", "0000003fffc0000007ff07ff0000", "0000003fffc0000007ff07ff0000", "0000007fff80000007ff07ff0000", "000000ffff00000007ff07ff0000", "000001fffe00000007ff07ff0000", "000001fffe00000007ff07ff0000", "000003fffc00000007ff07ff0000", "000007fff800000007ff07ff0000", "00000fffffffffffffff07ff0000", "00000fffffffffffffff07ff0000", "00001fffffffffffffff07ff0000", "00003fffffffffffffff07ff0000", "00007fffffffffffffff07ff0000", "00007fffffffffffffff07ff0000", "0000ffffffffffffffff07ff0000", "0001ffffffffffffffff07ff0000", "0001ffffffffffffffff07ff0000", "0003ffffffffffffffff07ff0000", "0007ffffffffffffffff07ff0000", "000fffffffffffffffff07ff0000", "000ffff000ffff0007ff07ff0000", "001fffe001fffe0007ff07ff0000", "003fffc003fffc0007ff07ff0000", "007fffc003fffc0007ff07ff0000", "007fff8007fff80007ff07ff0000", "00ffff000fffffffffffffffffff", "01fffe001fffffffffffffffffff", "03fffe001fffffffffffffffffff", "03fffc003fffffffffffffffffff", "07fff8007fffffffffffffffffff", "0ffff000ffffffffffffffffffff", "1ffff000ffffffffffffffffffff", "1fffe001ffffffffffffffffffff", "3fffc003ffffffffffffffffffff", "7fff8003ffffffffffffffffffff", "7fff8007ffffffffffffffffffff", "000000000000000007ff07ff8000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000", "000000000000000007ff07ff0000"] };
  var MARK_BOX = { l: 0.0919, t: 0.0018, w: 0.7982, h: 0.7083 };
  var LOGO_AR = 892 / 1121;
  var BG = '10,10,10';

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function bump(t, a, b) { if (t <= a || t >= b) return 0; return Math.sin((t - a) / (b - a) * Math.PI); }
  function ramp(t, a, b) { return clamp((t - a) / (b - a), 0, 1); }
  function rnd(a, b) { return a + Math.random() * (b - a); }

  function init(root) {
    var cv = root.querySelector('.a4-intro__cv');
    var ctx = cv.getContext('2d');
    var data = {};
    try { data = JSON.parse(root.querySelector('.a4-intro__data').textContent); } catch (e) {}
    var skip = root.querySelector('.a4-intro__skip');
    var font = data.font || 'Anton';
    // phrases: each entry is an array of lines
    var PHRASES = (data.phrases && data.phrases.length ? data.phrases : [['CREATE'], ['A BRIGHTER', 'FUTURE'], ['WITH ART.'], ['A4 GALLERY']]);

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seen = false;
    try { seen = data.once && sessionStorage.getItem('a4-intro-seen') === '1'; } catch (e) {}

    // ---- timeline (built from phrase count) ----
    var FLY = 1.45, HOLD = 1.0;
    var segs = [{ t0: 0, dur: 1.5, st: 0.6 }];         // phase 0: cards stream in
    var t = 2.7;                                         // cards drift until here
    for (var i = 0; i < PHRASES.length + 1; i++) {        // phrases + mark
      segs.push({ t0: t, dur: FLY, st: 0.55 });
      t += FLY + (i === PHRASES.length ? 0.5 : HOLD);
    }
    var REVEAL = [t, t + 0.8], END = t + 1.2;
    var glassAt = [];
    for (var g = 2; g < segs.length; g++) glassAt.push(segs[g].t0);
    glassAt.push(REVEAL[0] - 0.05);

    var W = 0, H = 0, DPR = 1;
    var buf = document.createElement('canvas'), bctx = buf.getContext('2d');
    var arts = [], events = [], logo = new Image();
    var parts = [], phaseS = [], logoRect = null, phL = [];
    var start = 0, offset = 0, raf = 0, done = false;
    var ptr = { x: -1e4, y: -1e4, lx: -1e4, ly: -1e4 };
    var trail = [];
    logo.src = data.logo;

    /* ---------- assets ---------- */
    function loadList(urls, into, max) {
      urls = (urls || []).slice(0, max);
      return new Promise(function (resolve) {
        var left = urls.length, fin = false;
        function end() { if (!fin) { fin = true; resolve(); } }
        if (!left) return end();
        urls.forEach(function (u) {
          var im = new Image();
          im.decoding = 'async';
          im.onload = function () { into.push(im); if (--left === 0) end(); };
          im.onerror = function () { if (--left === 0) end(); };
          im.src = u;
        });
        setTimeout(end, 3200);
      });
    }
    function loadFont() {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      return Promise.race([document.fonts.load('400 120px "' + font + '"'), new Promise(function (r) { setTimeout(r, 1800); })]).catch(function () {});
    }
    function loadLogo() {
      return new Promise(function (r) {
        if (logo.complete && logo.naturalWidth) return r();
        logo.onload = logo.onerror = function () { r(); };
        setTimeout(r, 3000);
      });
    }

    /* ---------- layout ---------- */
    function splitMobile(lines) {
      if (W >= 750) return lines;
      var out = [];
      lines.forEach(function (l) { l.split(' ').forEach(function (w) { if (w) out.push(w); }); });
      return out.length <= 3 ? out : lines;
    }
    function textTargets(lines) {
      lines = splitMobile(lines);
      var oc = document.createElement('canvas');
      oc.width = W; oc.height = H;
      var o = oc.getContext('2d');
      var fam = '"' + font + '", Impact, "Arial Narrow", sans-serif';
      var fs = 200, widest = 1;
      o.font = '400 ' + fs + 'px ' + fam;
      lines.forEach(function (l) { widest = Math.max(widest, o.measureText(l).width); });
      var lh = 1.02;
      fs = Math.min(fs * (W * (W < 750 ? 0.9 : 0.8)) / widest, (H * 0.66) / (lines.length * lh));
      o.font = '400 ' + fs + 'px ' + fam;
      o.textAlign = 'center';
      o.textBaseline = 'middle';
      o.fillStyle = '#000';
      var total = fs * lh * lines.length, y0 = H * 0.48 - total / 2 + fs * lh / 2;
      lines.forEach(function (l, i) { o.fillText(l, W / 2, y0 + i * fs * lh); });
      // tile size ≈ half the stroke width so every artwork stays readable
      var s = clamp(Math.round(fs * 0.074), W < 750 ? 12 : 16, 40);
      var px = o.getImageData(0, 0, W, H).data, pts = [];
      for (var y = s / 2; y < H; y += s) {
        for (var x = s / 2; x < W; x += s) {
          if (px[((y | 0) * W + (x | 0)) * 4 + 3] > 120) pts.push({ x: x, y: y });
        }
      }
      var mk = document.createElement('canvas'); mk.width = W * DPR; mk.height = H * DPR;
      var mc = mk.getContext('2d'); mc.setTransform(DPR, 0, 0, DPR, 0, 0);
      mc.fillStyle = 'rgb(' + BG + ')'; mc.fillRect(0, 0, W, H);
      mc.globalCompositeOperation = 'destination-out';
      mc.font = '400 ' + fs + 'px ' + fam; mc.textAlign = 'center'; mc.textBaseline = 'middle'; mc.fillStyle = '#000';
      lines.forEach(function (l, i) { mc.fillText(l, W / 2, y0 + i * fs * lh); });
      return { pts: pts, s: s, lines: lines, fs: fs, y0: y0, lh: lh, fam: fam, mask: mk };
    }
    function markTargets(s) {
      var lh = Math.min(H * 0.6, (W * 0.74) / LOGO_AR), lw = lh * LOGO_AR;
      logoRect = { x: (W - lw) / 2, y: (H - lh) / 2, w: lw, h: lh };
      var mx = logoRect.x + MARK_BOX.l * lw, my = logoRect.y + MARK_BOX.t * lh;
      var mw = MARK_BOX.w * lw, mh = MARK_BOX.h * lh;
      var cell = mw / MARK.c, st = s / cell, pts = [];
      for (var ry = st / 2; ry < MARK.r; ry += st) {
        var row = MARK.rows[ry | 0];
        for (var rx = st / 2; rx < MARK.c; rx += st) {
          var c = rx | 0;
          if (parseInt(row.charAt(c >> 2), 16) & (8 >> (c & 3))) pts.push({ x: mx + rx * cell, y: my + ry * (mh / MARK.r) });
        }
      }
      return { pts: pts, s: s };
    }

    // tiles cycle through the shuffled pool so every artist (and event photos) appears
    var bag = [];
    function refill() {
      bag = arts.slice();
      var evN = Math.round(arts.length * 0.3);
      for (var e = 0; e < evN && events.length; e++) bag.push(events[e % events.length]);
      for (var i = bag.length - 1; i > 0; i--) { var r = (Math.random() * (i + 1)) | 0, tmp = bag[i]; bag[i] = bag[r]; bag[r] = tmp; }
    }
    function pickImage(preferEvent) {
      if (preferEvent && events.length) return events[(Math.random() * events.length) | 0];
      if (!bag.length) refill();
      return bag.length ? bag.pop() : (events.length ? events[(Math.random() * events.length) | 0] : null);
    }
    function newPart(isCard) {
      var im = pickImage(isCard && Math.random() < 0.55);
      return {
        im: im, ar: im && im.naturalWidth ? im.naturalWidth / im.naturalHeight : 1,
        hue: (Math.random() * 360) | 0, jit: Math.random(),
        spin: (Math.random() < 0.5 ? -1 : 1) * rnd(1.2, 2.6) * Math.PI,
        flip: Math.random() < 0.6 ? (Math.random() < 0.5 ? -1 : 1) * Math.PI * 2 : 0,
        ox: 0, oy: 0, card: !!isCard
      };
    }

    function layout() {
      var r = root.getBoundingClientRect();
      W = Math.max(320, Math.round(r.width));
      H = Math.max(420, Math.round(r.height));
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = buf.width = W * DPR;
      cv.height = buf.height = H * DPR;
      cv.style.width = W + 'px';
      cv.style.height = H + 'px';
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);

      var ph = PHRASES.map(textTargets);
      phL = ph;
      var baseS = ph[0].s;
      var mk = markTargets(Math.max(12, Math.round(baseS * 0.62)));
      var all = ph.concat([mk]);
      all.forEach(function (a) { a.pts.sort(function (p, q) { return p.x - q.x || p.y - q.y; }); });

      var N = 0;
      all.forEach(function (a) { N = Math.max(N, a.pts.length); });
      var cardN = Math.min(W < 750 ? 18 : 34, N);

      // phase 0: drifting gallery of cards (big ones) + a field of smaller pieces
      var scatter = [];
      for (var i = 0; i < N; i++) {
        var big = i >= N - cardN;
        var sz = big ? rnd(W < 750 ? 90 : 150, W < 750 ? 170 : 300) : baseS * rnd(1.1, 2.2);
        scatter.push({ x: rnd(-0.05, 1.05) * W, y: rnd(0.04, 0.96) * H, s: sz });
      }
      phaseS = [0].concat(all.map(function (a) { return a.s; }));

      var old = parts;
      parts = [];
      for (var j = 0; j < N; j++) {
        var isCard = j >= N - cardN;
        var p = old[j] && old[j].card === isCard ? old[j] : newPart(isCard);
        p.k = [];
        p.k[0] = { x: scatter[j].x, y: scatter[j].y, s: scatter[j].s, a: 1, d: p.jit };
        p.vx = rnd(-14, 14) * (isCard ? 2.2 : 1); p.vy = rnd(-6, 6);
        for (var q = 0; q < all.length; q++) {
          var tg = all[q].pts[j];
          if (tg) p.k[q + 1] = { x: tg.x, y: tg.y, s: all[q].s, a: 1, d: clamp(tg.x / W, 0, 1) * 0.72 + p.jit * 0.28 };
          else {
            var prev = p.k[q];
            p.k[q + 1] = { x: prev.x + rnd(-0.3, 0.3) * W, y: prev.y + rnd(-0.4, 0.4) * H, s: prev.s * 0.6, a: 0, d: p.jit };
          }
        }
        var side = Math.random() < 0.5;
        p.k0 = { x: side ? rnd(-0.45, -0.1) * W : rnd(1.1, 1.45) * W, y: rnd(-0.1, 1.1) * H, s: scatter[j].s * 0.7, a: 1 };
        parts.push(p);
      }
    }

    /* ---------- drawing ---------- */
    function drawCard(p, x, y, s, a, rot, sx, ar, edge) {
      if (a <= 0.01 || s < 1) return;
      var w = s, h = s;
      if (ar > 1) h = s / ar; else w = s * ar;
      ctx.globalAlpha = a;
      var c = Math.cos(rot), si = Math.sin(rot);
      ctx.setTransform(DPR * c * sx, DPR * si * sx, -DPR * si, DPR * c, x * DPR, y * DPR);
      var im = p.im;
      if (im && im.naturalWidth) {
        var iw = im.naturalWidth, ih = im.naturalHeight, cw, ch;
        if (iw / ih > ar) { ch = ih; cw = ih * ar; } else { cw = iw; ch = iw / ar; }
        if (edge > 0.02) { ctx.fillStyle = 'rgba(245,243,238,' + edge + ')'; var b = Math.max(2, s * 0.025); ctx.fillRect(-w / 2 - b, -h / 2 - b, w + b * 2, h + b * 2); }
        ctx.drawImage(im, (iw - cw) / 2, (ih - ch) / 2, cw, ch, -w / 2, -h / 2, w, h);
      } else {
        ctx.fillStyle = 'hsl(' + p.hue + ',45%,55%)';
        ctx.fillRect(-w / 2, -h / 2, w, h);
      }
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    function currentSeg(t) {
      var k = 0;
      for (var i = 0; i < segs.length; i++) if (t >= segs[i].t0) k = i;
      return k;
    }

    function fluted(g, t) {
      if (g < 0.02) return;
      bctx.setTransform(1, 0, 0, 1, 0, 0);
      bctx.clearRect(0, 0, buf.width, buf.height);
      bctx.drawImage(cv, 0, 0);
      var sw = Math.max(16, Math.round(W / 30)), n = Math.ceil(W / sw);
      ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgb(' + BG + ')';
      ctx.fillRect(0, 0, W, H);
      for (var i = 0; i < n; i++) {
        var x = i * sw, off = Math.sin(i * 0.85 + t * 4.2) * sw * 0.9 * g;
        var srcW = sw / (1 + 0.35 * g);
        var sx = clamp(x + (sw - srcW) / 2 + off, 0, W - srcW);
        ctx.drawImage(buf, sx * DPR, 0, srcW * DPR, H * DPR, x, 0, sw, H);
      }
      var grd = ctx.createLinearGradient(0, 0, sw, 0);
      grd.addColorStop(0, 'rgba(255,255,255,' + 0.1 * g + ')');
      grd.addColorStop(0.35, 'rgba(255,255,255,0)');
      grd.addColorStop(0.85, 'rgba(0,0,0,0)');
      grd.addColorStop(1, 'rgba(0,0,0,' + 0.28 * g + ')');
      ctx.fillStyle = grd;
      for (var j = 0; j < n; j++) { ctx.setTransform(DPR, 0, 0, DPR, j * sw * DPR, 0); ctx.fillRect(0, 0, sw, H); }
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    function drawTrail(now) {
      for (var i = trail.length - 1; i >= 0; i--) {
        var q = trail[i], age = (now - q.born) / 1100;
        if (age >= 1) { trail.splice(i, 1); continue; }
        var e = easeOut(Math.min(1, age * 3));
        drawCard(q.p, q.x, q.y + age * 24, q.s * (0.6 + 0.4 * e) * (1 - age * 0.3), (1 - age), q.r * (1 - e) + q.r * 0.2, 1, q.p.ar, 0.6 * (1 - age));
      }
    }

    function frame(now) {
      raf = 0;
      var t = (now - start) / 1000 + offset;
      if (t >= END) { t = END; done = true; }
      var si = currentSeg(t), seg = segs[si];
      var span = Math.max(0.25, seg.dur - seg.st);
      var inFlight = !done && t < seg.t0 + seg.dur + 0.08;

      ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgba(' + BG + ',' + (inFlight ? 0.3 : 1) + ')';
      ctx.fillRect(0, 0, W, H);

      var warp = 1.2;
      for (var w = 0; w < glassAt.length; w++) warp += 10 * bump(t, glassAt[w] - 0.45, glassAt[w] + 0.25);
      var fade = 1 - easeInOut(ramp(t, REVEAL[0], REVEAL[1]));

      if (fade > 0.01) {
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i], to = p.k[si], from = si === 0 ? p.k0 : p.k[si - 1];
          var pr = clamp((t - seg.t0 - to.d * seg.st) / span, 0, 1);
          var e = si === 0 ? easeOut(pr) : easeInOut(pr);
          var x = lerp(from.x, to.x, e), y = lerp(from.y, to.y, e);
          var s = lerp(from.s, to.s, e);
          // cards keep drifting while they float in the opening
          var drift = 0;
          if (si === 0) { drift = Math.max(0, t - 0.2); x += p.vx * drift; y += p.vy * drift; }
          if (si === 1) { var dd = Math.max(0, seg.t0 - 0.2) * (1 - e); x += p.vx * dd; y += p.vy * dd; }
          // lift in an arc while flying
          y -= Math.sin(e * Math.PI) * H * 0.08 * (p.jit - 0.5);
          s *= 1 + 0.35 * Math.sin(e * Math.PI) * (si > 0 ? 1 : 0);
          var a = lerp(from.a, to.a, e) * fade;
          // spin + card flip while travelling, settle flat on arrival
          var rot, sx;
          if (si === 0) { rot = (p.card ? 0.12 : 0.6) * Math.sin(t * 0.7 + p.jit * 6) + (1 - e) * p.spin * 0.4; sx = 1; }
          else { rot = (1 - e) * p.spin; sx = p.flip ? Math.cos((1 - e) * p.flip) : 1; if (Math.abs(sx) < 0.06) sx = sx < 0 ? -0.06 : 0.06; }
          var ar = si === 0 ? p.ar : (si === 1 ? lerp(p.ar, 1, e) : 1);
          var edge = si === 0 ? (p.card ? 0.9 : 0) : (si === 1 ? (p.card ? 0.9 * (1 - e) : 0) : 0);
          if (si > 0 && pr >= 1) {
            x += Math.sin(y * 0.03 + t * 2.6) * warp;
            y += Math.cos(x * 0.028 + t * 2.1) * warp * 0.5;
            var dx = x - ptr.x, dy = y - ptr.y, d2 = dx * dx + dy * dy, R = Math.max(90, to.s * 5);
            var wx = 0, wy = 0;
            if (d2 < R * R) { var d = Math.sqrt(d2) || 1, f = (R - d) / R; wx = (dx / d) * f * R * 0.5; wy = (dy / d) * f * R * 0.5; rot += f * 0.4 * (p.jit - 0.5); }
            p.ox += (wx - p.ox) * 0.18; p.oy += (wy - p.oy) * 0.18;
            x += p.ox; y += p.oy;
          }
          drawCard(p, x, y, s * (si === 0 ? 1 : 1.04), a, rot, sx, ar, edge);
        }
      }

      // readable lettering: crisp outline once the tiles have settled into the phrase
      if (si >= 1 && si <= PHRASES.length && fade > 0.01 && phL[si - 1]) {
        var L = phL[si - 1], sEnd = seg.t0 + seg.dur, nxt = segs[si + 1] ? segs[si + 1].t0 : REVEAL[0];
        var oa = easeOut(ramp(t, sEnd - 0.2, sEnd + 0.35)) * (1 - ramp(t, nxt - 0.12, nxt + 0.18)) * fade;
        if (oa > 0.01) {
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.globalAlpha = oa;
          ctx.drawImage(L.mask, 0, 0);   // trim every tile to the letter shapes
          ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
          ctx.font = '400 ' + L.fs + 'px ' + L.fam;
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
          ctx.globalAlpha = oa;
          ctx.strokeStyle = 'rgba(255,255,255,0.9)'; ctx.lineWidth = Math.max(1.4, L.fs * 0.012);
          L.lines.forEach(function (l, i) { ctx.strokeText(l, W / 2, L.y0 + i * L.fs * L.lh); });
          ctx.globalAlpha = 1;
        }
      }

      drawTrail(now);

      var la = easeInOut(ramp(t, REVEAL[0] + 0.15, REVEAL[1]));
      if (la > 0.01 && logo.naturalWidth && logoRect) {
        ctx.globalAlpha = la;
        ctx.drawImage(logo, logoRect.x, logoRect.y, logoRect.w, logoRect.h);
        ctx.globalAlpha = 1;
      }

      var gl = 0;
      for (var k = 0; k < glassAt.length; k++) gl = Math.max(gl, (k === glassAt.length - 1 ? 0.9 : 0.75) * bump(t, glassAt[k] - 0.25, glassAt[k] + (k === glassAt.length - 1 ? 1.0 : 0.6)));
      fluted(gl, t);

      if (t >= REVEAL[1]) root.classList.add('is-done');
      if (!done || trail.length) raf = requestAnimationFrame(frame);
      else { try { sessionStorage.setItem('a4-intro-seen', '1'); } catch (e) {} }
    }

    function onMove(ev) {
      var r = cv.getBoundingClientRect();
      var x = ev.clientX - r.left, y = ev.clientY - r.top;
      ptr.x = x; ptr.y = y;
      var dx = x - ptr.lx, dy = y - ptr.ly;
      if (dx * dx + dy * dy > 60 * 60 && root.classList.contains('is-done')) {
        ptr.lx = x; ptr.ly = y;
        trail.push({ p: newPart(true), x: x, y: y, s: (W < 750 ? 90 : 150) * rnd(0.8, 1.15), r: rnd(-0.5, 0.5), born: performance.now() });
        if (trail.length > 24) trail.shift();
        if (!raf) raf = requestAnimationFrame(function (n) { start = n - (END - offset) * 1000; frame(n); });
      }
    }
    function onLeave() { ptr.x = ptr.y = -1e4; }
    function jumpToEnd() { offset = END; start = performance.now(); done = false; if (!raf) raf = requestAnimationFrame(frame); }

    Promise.all([
      loadList(data.images, arts, 120),
      loadList(data.events, events, 24),
      loadFont(), loadLogo()
    ]).then(function () {
      layout();
      root.classList.add('is-ready');
      if (reduce) offset = END;
      else if (seen) offset = segs[segs.length - 1].t0 + FLY - 0.3;
      start = performance.now();
      raf = requestAnimationFrame(frame);

      cv.addEventListener('pointermove', onMove, { passive: true });
      cv.addEventListener('pointerleave', onLeave, { passive: true });
      if (skip) skip.addEventListener('click', jumpToEnd);

      var rt = 0;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          var tt = (performance.now() - start) / 1000 + offset;
          var w0 = W;
          layout();
          if (Math.abs(W - w0) < 2 && done) { offset = END; }
          if (!raf) { offset = Math.min(tt, END); start = performance.now(); done = false; raf = requestAnimationFrame(frame); }
        }, 200);
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var vis = en[0].isIntersecting;
          if (!vis && raf) { cancelAnimationFrame(raf); raf = 0; offset = Math.min((performance.now() - start) / 1000 + offset, END); }
          else if (vis && !raf && !done) { start = performance.now(); raf = requestAnimationFrame(frame); }
        }, { threshold: 0.05 }).observe(root);
      }
    });
  }

  function boot() { document.querySelectorAll('[data-a4-intro]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
